import { render } from "./SideContent.vue?vue&type=template&id=6d6d6fc2&scoped=true"
import script from "./SideContent.vue?vue&type=script&lang=js"
export * from "./SideContent.vue?vue&type=script&lang=js"

import "./SideContent.vue?vue&type=style&index=0&id=6d6d6fc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6d6fc2"]])

export default __exports__